import axios from 'axios';

export type PostRequestData = {
  url: string;
  data: any;
  contentType?: string;
  responseType?: any;
};

export const postRequest = async (
  postRequestData: PostRequestData,
): Promise<any> => {
  const { url, data, responseType = 'json', contentType } = postRequestData;
  const defaultContentType =
    data instanceof FormData ? 'multipart/form-data' : 'application/json';
  const headers: Record<string, string> = {
    'Content-Type': contentType ?? defaultContentType,
    'current-role': localStorage.getItem('currentRole') ?? '',
    authorization: localStorage.getItem('tokens') ?? '',
  };

  const response = await axios({
    url,
    method: 'POST',
    data,
    responseType,
    headers,
  });

  return response;
};
